import { FormColumns, FormLabel } from "components/form";
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "ui/components/form";

import CurrencyInput from "components/currency/input";
import { Input } from "ui/components/input";
import { PermissionControlledInput } from "permissions/components/input";
import React from "react";
import { usePrivacy } from "contexts/privacy";
import { maskPrivacyAmount } from "utils/utils";

const AmountWithCurrencyInput = ({
  form,
  amountKey,
  amountLabel,
  disabled,
  required,
  rule = "create:SC,AM",
  disableCurrency,
  collection = "dedicated_job_config",
  // amountInputType = "text",
}) => {
  return (
    <FormColumns>
      <FormField
        control={form.control}
        name={amountKey}
        render={({ field }) => (
          <FormItem>
            <PermissionControlledInput
              rule={rule}
              collection={collection}
              field={field.name}
              type="form"
            >
              <FormLabel required={required.includes(amountKey)}>
                {amountLabel}
              </FormLabel>

              <Input
                type="number"
                {...field}
                value={field.value}
                onChange={(e) => {
                  field.onChange(
                    e.target.value === "" ? null : Number(e.target.value),
                  );
                }}
                disabled={disabled}
              />
            </PermissionControlledInput>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="currency"
        render={({ field }) => (
          <FormItem>
            <PermissionControlledInput
              rule={rule}
              collection={collection}
              field={field.name}
              type="form"
            >
              <FormLabel required={required.includes(field.name)}>
                Currency
              </FormLabel>

              <CurrencyInput
                {...field}
                disabled={
                  disableCurrency !== undefined ? disableCurrency : disabled
                }
              />
            </PermissionControlledInput>
            <FormMessage />
          </FormItem>
        )}
      />
    </FormColumns>
  );
};

export default AmountWithCurrencyInput;
